import React from "react";
import {
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Paper,
  Typography,
} from "@mui/material";

const steps = [
  {
    label: "term1",
    description: "仲間を知る 9/1 - 9/22",
    content:
      "●八重の誓いを使って自己紹介し、 お互いの共通点を見つけましょう。\n●八重の誓いを通しての気づきをシェアしましょう。\n●DDPを共有し、フィードバックし合いましょう。",
  },
  {
    label: "term2",
    description: "深層を掘り下げ、具体化する 9/23 - 10/26",
    content:
      "●八重の誓いを通しての変化や気づきをシェアしましょう\n●DDPを中心に置き曼荼羅チャートを作成し、シェアし合いましょう",
  },
  {
    label: "term3",
    description: "自分を統合し、新たな一歩を踏み出す 10/26 - 11/22",
    content:
      "●「八重の誓い」を通して得た変化や気づきをシェアしましょう。\n●曼荼羅チャートをもとに、具体的に取り組みたいことを書き出しましょう。\n●その中から一つ選び、「行動を変えるために毎日30分取り組むこと」を決めましょう。\n●決めた内容を毎日チャットなどで報告し合い、仲間同士で応援し合いましょう。\n＊推奨：毎日同じ時間帯に、みんなで取り組む時間を決めて実践しましょう。",
  },
  {
    label: "term4",
    description: "他者を鏡に自分を知り、新しい私を動かす 11/23-12/21",
    content:
      "●八重の誓いの取り組めていない質問について、メンバー同士で協力しながら回答を進めましょう。\n●「八重の誓い」の中から印象的な質問をピックアップし、写真や絵を使って形（イメージボードなど）にしてみましょう。\n●「青い宝物は何か？」「宝物を取って浮上し、深い呼吸ができる今の状況」について、\n●自分自身の気づきに加え、他のメンバーから見た自分についても互いにシェアしてみましょう。\n●毎日30分間の取り組みを継続しましょう。\n●毎日チャット等で取り組み状況を報告、応援のコメントをし合いましょう",
  },
];

const Schedule2025HL = () => {
  const [activeStep, setActiveStep] = React.useState(0);

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  return (
    <div
      style={{
        width: "100%",
        marginTop: "16px",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div style={{ maxWidth: "600px" }}>
        <Stepper activeStep={activeStep} orientation="vertical">
          {steps.map((step, index) => (
            <Step key={step.label}>
              <StepLabel onClick={handleStep(index)}>
                {step.label} - {step.description}
              </StepLabel>
              <StepContent>
                {step.content.split("\n").map((line, idx) => (
                  <Typography key={idx}>{line}</Typography>
                ))}
              </StepContent>
            </Step>
          ))}
        </Stepper>
        {/* {activeStep === steps.length && (
            <Paper square elevation={0} style={{ padding: '16px' }}>
              <Typography>All steps completed - you&apos;re finished</Typography>
            </Paper>
          )} */}
      </div>
    </div>
  );
};

export default Schedule2025HL;
